import type { PantryItem } from "./types";

/** Normalize a DB date string (ISO timestamp or YYYY-MM-DD) to YYYY-MM-DD for <input type="date">. */
export function toDateInputValue(v: string | null | undefined): string {
  if (!v) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
  const d = new Date(v);
  return isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
}

export function isExpiringSoon(dateStr: string | null): boolean {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  const now = new Date();
  const diff = (d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
  return diff <= 7 && diff >= 0;
}

export function isExpired(dateStr: string | null): boolean {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date();
}

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("sk-SK");
}

export function formatAmount(item: PantryItem): string {
  const m = parseFloat(item.mnozstvo);
  const u = item.jednotka;
  if (u === "g" || u === "kg") return `${m} ${u}`;
  if (u === "ks") return `${m} ks`;
  if (u === "balenie") return `${m} bal.`;
  return `${m} ${u}`;
}

export function formatAvailable(
  item: PantryItem,
  t: (key: string, options?: any) => string
): string {
  const g = parseFloat(item.dostupneG);
  if (g >= 1000)
    return t("mealLibrary:spajza.availableKg", {
      amount: (g / 1000).toFixed(2),
    });
  return t("mealLibrary:spajza.availableG", { amount: g.toFixed(0) });
}
